import { msg } from 'gt-react';
import { SealCheckIcon } from '@phosphor-icons/react';
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { Action, Subject } from '@erp/authz';
import { ProductModule } from '@erp/shared-types';
import { Route as pathlessAuthenticatedRoute } from '../../route';
import { requireSdAdmin } from '../sdAdminRouteAccess';

const Edi997AcknowledgementsPage = lazyRouteComponent(
  () => import('./Edi997AcknowledgementsPage'),
  'Edi997AcknowledgementsPage',
);

export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/ship-and-debit/edi-997-acknowledgements',
  staticData: {
    app: {
      nav: {
        label: msg('EDI 997 Acknowledgements', {
          context: 'sidebar nav label, Ship and Debit Admin section',
        }),
        icon: <SealCheckIcon className="h-4 w-4" weight="fill" />,
        group: 'Ship and Debit Admin',
        order: 22,
      },
      // Inline: the route-rbac lint reads the permission from this block.
      access: {
        modulesAnyOf: [ProductModule.SHIP_AND_DEBIT],
        permissionsAnyOf: [{ action: Action.Read, subject: Subject.SDAdmin }],
      },
    },
  },
  component: Edi997AcknowledgementsPage,
  loader: () => ({
    crumb: msg('EDI 997 Acknowledgements', { context: 'page breadcrumb' }),
  }),
  beforeLoad: requireSdAdmin,
});
